var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-container"},[_c('van-divider'),_c('div',{staticClass:"showHis"},[_c('p',{staticClass:"hisTips"},[_vm._v("搜索记录")]),_vm._l((_vm.historyList),function(his,i){return [_c('van-cell',{key:i,attrs:{"title":his,"icon":"clock-o"},on:{"click":function($event){return _vm.hisSearch(his)}}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }